import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";

export const expedienteSiniestroService = {
  getExpedientesSiniestros,
  postExpedienteSiniestro,
  putExpedienteSiniestro,
  getExpedienteSiniestroById,
  getExcel,
};

function getExpedientesSiniestros(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/expedientes-siniestros`;
  const pagination_service = {
    page: pagination.currentPage - 1,
    limit: pagination.perPage,
  };

  const params = new URLSearchParams({ ...pagination_service, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function postExpedienteSiniestro(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/expedientes-siniestros`;
  return axios.post(urlPath, request);
}

function putExpedienteSiniestro(id, request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/expedientes-siniestros/${id}`;
  return axios.put(urlPath, request);
}

function getExpedienteSiniestroById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/expedientes-siniestros/${id}`;
  return axios.get(urlPath);
}

function getExcel(filters) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/expedientes-siniestros/excel`;
  const params = new URLSearchParams({ ...filters, ...{ limit: 2000 } });
  urlPath += `?${params.toString()}`;

  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}
